import { FC } from "preact/compat";
import { useApp } from "~/core";
import HelpIcon from "@material-design-icons/svg/outlined/question_mark.svg";

const HelpModeTooltip: FC = () => {
    const {
        help: { isDiscovery },
    } = useApp();

    if (isDiscovery.value) {
        return (
            <div>
                <p>
                    You are in <strong>Help Mode</strong>. To{" "}
                    <strong>exit</strong>, click this{" "}
                    <HelpIcon className="inline" width="16" height="16" /> icon
                    again.
                </p>
                <ol className="ml-4 mt-2 list-disc">
                    <li>
                        <strong>Click</strong> on a{" "}
                        <HelpIcon className="inline" width="16" height="16" />{" "}
                        icon next to a function for{" "}
                        <strong>context-specific guidance</strong>.
                    </li>
                    <li>
                        <strong>Hover</strong> over a{" "}
                        <HelpIcon className="inline" width="16" height="16" />{" "}
                        icon to see a <strong>brief overview</strong> of the
                        function.
                    </li>
                </ol>
            </div>
        );
    }

    return (
        <div>
            <p>
                In any section of <strong>Engage</strong>, click on this{" "}
                <HelpIcon className="inline" width="16" height="16" /> icon to{" "}
                <strong>activate Help Mode</strong>.
            </p>
            <p className="mt-2">
                When <strong>Help Mode</strong> is active,
                <HelpIcon className="inline" width="16" height="16" /> icons
                appear next to certain functions throughout the application for
                your guidance.
            </p>
        </div>
    );
};

export default HelpModeTooltip;
